import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
// import creatHistory from 'history/creatHistory'


ReactDOM.render(
  <App />,
  document.getElementById('root')
);

